/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import {
  searchInvoiceRequestAction,
  setSelectedClient,
} from '../../../Display/invoice/store/actions';
import { searchInvoiceReportAction } from '../../../Display/InvoiceReport/store/actions';
import { aesEncrypt, aesDecrypt } from '../../../../SharedModules/utilities/Encryption';

export const dispatchGetUserDefaults = (data) => {
  return {
    type: actionTypes.GET_USER_DEFAULTS,
    UserDefaultsValues: data,
  };
};

export const dispatchAllRebateProgramCode = (data) => {
  return {
    type: actionTypes.GET_ALL_REBATE_PROGRAMS,
    rebateProgramCode: data,
  };
};
export const dispatchGetAllClientCode = (data) => {
  return {
    type: actionTypes.GET_ALL_CLIENT_CODE,
    clientCode: data,
  };
};
export const dispatchGetAllplanCode = (data) => {
  return {
    type: actionTypes.GET_ALL_PLAN,
    planCode: data,
  };
};
export const dispatchGetAllGroupCode = (data) => {
  return {
    type: actionTypes.GET_ALL_GROUP,
    groupCode: data,
  };
};
export const dispatchGetAllCheckPayeeCode = (data) => {
  return {
    type: actionTypes.GET_CHECK_PAYEE,
    checkPayeeCode: data,
  };
};
export const dispatchUpdateUserDefaults = (data) => {
  return {
    type: actionTypes.UPDATE_USER_DEFALTS,
    update: data,
  };
};

export const dispatchValidateCheckPayee = (data) => {
  return {
    type: actionTypes.VALIDATE_CHECK_PAYEE,
    validateCheckPayee: data,
  };
};

export const dispatchTabChanges = (data) => {
  return {
    type: actionTypes.GET_TAB_CHANGES,
    payload: data,
  };
};

let isGetUserDefaultsInProgress = false;
export const getUserDefaults = (userIdUC) => async (dispatch, getState) => {
  if (!userIdUC) return;

  if (isGetUserDefaultsInProgress) {
    return;
  }

  isGetUserDefaultsInProgress = true;

  let requestUrl;
  try {
    // const encryptedUserId = aesEncrypt(userIdUC);
    requestUrl = `${serviceEndPoint.GET_USER_DEFAULTS}?userId=${userIdUC}`;
  } catch (encryptionError) {
    requestUrl = `${serviceEndPoint.GET_USER_DEFAULTS}?userId=${userIdUC}`;
  }

  try {
    const response = await axios.post(requestUrl);
    const { searchInvoiceRequest, selectedClient } = getState().sharedState.DisplayInvoiceReducer;
    dispatch(
      searchInvoiceRequestAction({
        ...searchInvoiceRequest,
        rebateProgramCode: response?.data?.data?.rebateProgramCd
          ? response?.data?.data?.rebateProgramCd
          : searchInvoiceRequest.rebateProgramCode,
        planType: response?.data?.data?.planTypeCd
          ? response.data.data.planTypeCd
          : searchInvoiceRequest.planType,
      })
    );
    dispatch(
      searchInvoiceReportAction({
        ...searchInvoiceRequest,
        rebateProgramCode: response?.data?.data?.rebateProgramCd
          ? response?.data?.data?.rebateProgramCd
          : searchInvoiceRequest.rebateProgramCode,
        planType: response?.data?.data?.planTypeCd
          ? response.data.data.planTypeCd
          : searchInvoiceRequest.planType,
      })
    );
    dispatch(
      setSelectedClient(
        response?.data?.data?.defInvoiceSelectModeCd
          ? response?.data?.data?.defInvoiceSelectModeCd
          : selectedClient
      )
    );
    return dispatch(dispatchGetUserDefaults(response.data));
  } catch (response) {
    dispatch(dispatchGetUserDefaults(response));
  } finally {
    isGetUserDefaultsInProgress = false;
  }
};

export const updatUserDefaults = (values, id) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.UPDATE_USER_DEFALTS}`, values)
    .then((response) => {
      dispatch(getUserDefaults(id));
      return dispatch(dispatchUpdateUserDefaults(response.data));
    })
    .catch((response) => {
      dispatch(dispatchUpdateUserDefaults(response));
    });
};
export const getRebateProgramCode = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`, { planType: values })
    .then((response) => {
      return dispatch(dispatchAllRebateProgramCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchAllRebateProgramCode(response.date));
    });
};

export const getClientCode = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_CLIENT_CODE}`, values)
    .then((response) => {
      return dispatch(dispatchGetAllClientCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchGetAllClientCode(response.date));
    });
};

export const getAallPlanCode = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_PLAN}`, values)
    .then((response) => {
      return dispatch(dispatchGetAllplanCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchGetAllplanCode(response.date));
    });
};
export const getAllgroupCode = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_GROUP}`, values)
    .then((response) => {
      return dispatch(dispatchGetAllGroupCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchGetAllGroupCode(response.date));
    });
};
export const getCheckPayeeCode = (values) => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.GET_CHECK_PAYEE}?codeDomainKey=CHECK_PAYEE_CD`)
    .then((response) => {
      return dispatch(dispatchGetAllCheckPayeeCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchGetAllCheckPayeeCode(response));
    });
};
export const getValidateCheckPayee = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.VALIDATE_CHECK_PAYEE}`, values)
    .then((response) => {
      return dispatch(dispatchValidateCheckPayee(response.data));
    })
    .catch((response) => {
      dispatch(dispatchValidateCheckPayee(response));
    });
};
export const dispatchSetOverride508Compliance = (value) => {
  return {
    type: actionTypes.SET_OVERRIDE_508_COMPLIANCE,
    payload: value,
  };
};
export const clearReduxUserDefaultScreen = () => (dispatch) => {
  dispatch(dispatchAllRebateProgramCode([]));
  dispatch(dispatchGetAllCheckPayeeCode([]));
  dispatch(dispatchGetAllGroupCode([]));
  dispatch(dispatchUpdateUserDefaults({}));
  dispatch(dispatchTabChanges({}));
};
